module.exports = __webpack_public_path__ + "static/media/type_related.45e43a43.png";